import React from 'react'
import s from './callouts.module.css'

const Callout = (props) => (
  <div className={`${s.callout} ${props.className}`}>
    {props.children}
  </div>
)

Callout.defaultProps = {
  className: '',
};

export default Callout
